<template>
  <lateral-modal
    id="cardsScheduleModal"
    :title="$t('company_cards_schedule_settings_modal_title')"
    @close="handleClose"
  >
    <template slot="content">
      <p class="cards-schedule--description">
        {{ $t('company_cards_schedule_settings_description') }}
      </p>
      <div class="Fuell-Table--header">
        <div class="Fuell-Table--item">
          <span v-t="{ path: 'company_cards_schedule_table_name_header' }"></span>
        </div>
        <div class="Fuell-Table--item">
          <span v-t="{ path: 'company_cards_schedule_table_days_header' }"></span>
        </div>
        <div class="Fuell-Table--item">
          <span v-t="{ path: 'company_cards_schedule_table_hours_header' }"></span>
        </div>
        <div class="Fuell-Table--item">
          <span v-t="{ path: 'company_cards_schedule_table_budgets_header' }"></span>
        </div>
        <div class="Fuell-Table--item"><span></span></div>
      </div>
      <div v-if="cardsScheduleReady">
        <div
          v-for="(cardSchedule,index) in cardsSchedule"
          :key="cardSchedule.id"
          class="Fuell-Table--row"
        >
          <div class="Fuell-Table--item">
            <transition name="text-transition">
              <div
                v-if="!cardSchedule.editable"
                key="1"
                class="Fuell-Table--item--text Fuell-Text--name"
                @click="editCardSchedule(cardSchedule)"
              >
                <p class="Fuell-Text ellipsis">
                  {{cardSchedule.name}}
                </p>
                <img
                  class="cards-schedule--edit-icon"
                  alt="icon-edit"
                  :src="require('@/assets/img/icons/icon-edit.svg')"
                />
              </div>
            </transition>
            <transition name="input-transition">
              <div
                v-if="cardSchedule.editable"
                key="2"
                class="d-flex align-items-center"
              >
                <div
                  class="close-container"
                  @click="notEditCardSchedule(cardSchedule)"
                >
                  <span class="close-line"></span>
                </div>
                <div
                  class="Form-field Form-field--name"
                  :class="{'Form--field-error' : $v.cardsSchedule.$each[index].name.$error}"
                >
                  <input
                    class="Input-text"
                    type="text"
                    @blur="$v.cardsSchedule.$each[index].name.$touch()"
                    v-model="cardSchedule.name"
                    :placeholder="$t('company_cards_schedule_table_card_schedule_name_placeholder')"
                  >
                </div>
              </div>
            </transition>
          </div>
          <div class="Fuell-Table--item Fuell-Table--item--options">
            <transition name="text-transition">
              <div
                v-if="!cardSchedule.editable"
                key="1"
                class="Fuell-Table--item--text Fuell-Text--days"
                @click="editCardSchedule(cardSchedule)"
              >
                <p class="Fuell-Text ellipsis">
                  <span
                    v-for="(day, index) in daysSelected(cardSchedule.days)"
                    :key="index"
                  >
                    {{$t(`day_of_week_${day}_abbr`)}}<span v-if="(index + 1) < daysSelected(cardSchedule.days).length">,</span>
                  </span>
                </p>
                <img
                  class="cards-schedule--edit-icon"
                  alt="icon-edit"
                  :src="require('@/assets/img/icons/icon-edit.svg')"
                />
              </div>
            </transition>
            <transition name="input-transition">
              <div
                v-if="cardSchedule.editable"
                class="Form-field--days"
                key="2"
              >
                <span
                  v-for="(day, key) in days"
                  :key="key"
                  :class="{'active': cardSchedule.days[key]}"
                  class="day-selectable"
                  @click="selectDay(cardSchedule, key)"
                >
                  {{$t(`day_of_week_${key}_abbr`)}}
                </span>
              </div>
            </transition>
          </div>
          <div class="Fuell-Table--item Fuell-Table--item--options">
            <transition name="text-transition">
              <div
                v-if="!cardSchedule.editable"
                key="1"
                class="Fuell-Table--item--text Fuell-Text--hours"
                @click="editCardSchedule(cardSchedule)"
              >
                <p class="Fuell-Text ellipsis">
                  {{cardSchedule.hours.startHour}}
                  <span class="cards-schedule-day-of-week--to-range">{{$t('keyword_to_range')}}</span>
                  {{cardSchedule.hours.finishHour}}
                </p>
                <img
                  class="cards-schedule--edit-icon"
                  alt="icon-edit"
                  :src="require('@/assets/img/icons/icon-edit.svg')"
                />
              </div>
            </transition>
            <transition name="input-transition">
              <div
                v-if="cardSchedule.editable"
                key="2"
                class="Form-field--hours cards-schedule-day-of-week--container-multiselect"
              >
                <multiselect
                  :options="showHoursAvailables(cardSchedule.hours.finishHour, 'start')"
                  v-model="cardSchedule.hours.startHour"
                  :allowEmpty="false"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                  placeholder=""
                  class="multiselect-start"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                </multiselect>
                <span class="cards-schedule-day-of-week--to-range">{{$t('keyword_to_range')}}</span>
                <multiselect
                  :options="showHoursAvailables(cardSchedule.hours.startHour, 'finish')"
                  v-model="cardSchedule.hours.finishHour"
                  :allowEmpty="false"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                  placeholder=""
                  class="multiselect-finish"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                </multiselect>
              </div>
            </transition>
          </div>
          <div class="Fuell-Table--item Fuell-Table--item--options">
            <transition name="text-transition">
              <div
                v-if="!cardSchedule.editable"
                v-tooltip="cardScheduleBudgets(cardSchedule)"
                key="1"
                class="Fuell-Table--item--text Fuell-Text--budgets"
                @click="editCardSchedule(cardSchedule)"
              >
                <!-- 9 horas -->
                <p class="Fuell-Text ellipsis">
                  {{cardScheduleBudgets(cardSchedule)}}
                </p>
                <img
                  class="cards-schedule--edit-icon"
                  alt="icon-edit"
                  :src="require('@/assets/img/icons/icon-edit.svg')"
                />
              </div>
            </transition>
            <transition name="input-transition">
              <div
                v-if="cardSchedule.editable"
                class="Form-field--budgets"
                key="2"
              >
                <multi-select-custom
                  v-model="cardSchedule.budgets"
                  :options="budgets"
                  :track-by="'id'"
                  :label="['name']"
                  :placeholder="$t('company_cards_schedule_table_budgets_placeholder')"
                  :classList="'multiselect--budgets'"
                  :closeOnSelect="false"
                  @setSelectedItems="checkBudgets(cardSchedule, $event)"
                  @removeItem="removeBudget(cardSchedule,$event)"
                  @close="$v.cardsSchedule.$each[index].budgets.$touch()"
                ></multi-select-custom>
              </div>
            </transition>
          </div>
          <div class="Fuell-Table--item Fuell-Table--item--last">
            <transition name="text-transition">
              <button
                v-if="cardSchedule.editable"
                key="1"
                class="button-borderless text-primary clickable"
                :class="{'disabled' : validateSchedule($v.cardsSchedule.$each[index].$invalid, cardSchedule.days)}"
                :disabled="validateSchedule($v.cardsSchedule.$each[index].$invalid, cardSchedule.days)"
                @click="handleSaveCardSchedule(cardSchedule)"
              >{{$t('ACTION_SAVE')}}</button>
            </transition>
            <transition name="text-transition">
              <div
                v-if="!cardSchedule.editable"
                key="2"
                class="d-flex justify-content-center"
              >
                <span
                  class="Ctrl Ctrl--16 u-pointer remove-icon"
                  @click="handleDeleteCardSchedule(cardSchedule)"
                >
                  <svg
                    focusable="false"
                    aria-hidden="true"
                    aria-label="Edit"
                  >
                    <use xlink:href="#close-icon"></use>
                  </svg>
                </span>
              </div>
            </transition>
          </div>
        </div>
        <button
          class="Fuell-button Fuell-button--primary p-2"
          @click="addCardSchedule"
        >{{$t('company_cards_schedule_add_card_schedule_action')}}</button>
      </div>
      <div
        class="flex center"
        v-else
      >
        <spinner spinner-class-list="text-secondary"></spinner>
      </div>
      <div class="cards-schedule--default">
        <p class="cards-schedule--default-title">
          {{ $t('company_cards_schedule_settings_default_title') }}
        </p>
        <p class="cards-schedule--default-description">
          {{ $t('company_cards_schedule_settings_default_description') }}
        </p>
        <label class="form--label mb-0">{{$t('company_cards_schedule_settings_default_label').toUpperCase()}}</label>
        <multiselect
          :options="cardsSchedule"
          v-model="defaultSchedule"
          label="name"
          :allowEmpty="false"
          selectLabel=""
          selectedLabel=""
          deselectLabel=""
          :placeholder="$t('MULTISELECT_DEFAULT_SELECT_LABEL')"
          class="multiselect-start"
          @select="changeDefaultSchedule"
        >
          <div
            class="caret"
            slot="caret"
            slot-scope="{ toggle }"
            @mousedown.prevent.stop="toggle"
          >
            <i
              class="Ctrl Ctrl--16"
              aria-hidden="true"
            >
              <svg
                focusable="false"
                aria-hidden="true"
                aria-label="Edit"
              >
                <use xlink:href="#dropdown-icon"></use>
              </svg>
            </i>
          </div>
        </multiselect>
      </div>
    </template>
    <template slot="modals">
      <confirm-modal
        :id="'confirm-delete-modal'"
        :open.sync="showConfirmDeleteFlag"
        v-if="showConfirmDeleteFlag"
        :title="'company_cards_schedule_modal_confirm_delete'"
        :message="'company_cards_schedule_modal_confirm_delete_warning'"
        @accept="deleteCardSchedule"
        :acceptText="'ACTION_REMOVE'"
        :dismissText="'ACTION_CANCEL'"
      >
      </confirm-modal>
      <confirm-modal
        :id="'repeated-budgets-modal'"
        :open.sync="showRepeatedBudgetsFlag"
        v-if="showRepeatedBudgetsFlag"
        :title="'company_cards_schedule_modal_overwrite_budget'"
        :message="repeatedBudgets.length === 1 ? 'company_cards_schedule_modal_overwrite_budget_single' : 'company_cards_schedule_modal_overwrite_budget_multiple'"
        @accept="overwriteBudgetCardSchedule"
        :acceptText="'ACTION_ASSIGN'"
        :dismissText="'ACTION_CANCEL'"
        dismissBtnClass="danger"
        acceptBtnClass="blue"
      >
        <template slot="content">
          <ul class="cards-schedule--repeated">
            <li
              v-for="(budget, index) in repeatedBudgets"
              :key="index"
            >
              {{budget.name}}
            </li>
          </ul>
        </template>
      </confirm-modal>
    </template>
  </lateral-modal>
</template>

<script>
import Multiselect from 'vue-multiselect'
import MultiSelectCustom from '@/components/Commons/Forms/MultiSelectCustom'
import Spinner from '@/components/Commons/Spinner'
import { hoursADay15Minutes, days } from '@/utils/constants'
import ConfirmModal from '@/components/Commons/ConfirmModal'
import officeApi from '@/modules/company/_api/'
import LateralModal from '@/components/Commons/Modals/LateralModal'

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
const { validationMixin } = require('vuelidate')
const { required, minLength } = require('vuelidate/lib/validators')

export default {
  components: {
    Multiselect,
    MultiSelectCustom,
    Spinner,
    ConfirmModal,
    LateralModal
  },
  data () {
    return {
      cardsScheduleReady: false,
      showNoResults: false,
      cardsSchedule: [],
      cardScheduleFakeId: 0,
      isCallingApi: false,
      showConfirmDeleteFlag: false,
      showRepeatedBudgetsFlag: false,
      cardScheduleIdToDelete: 0,
      defaultSchedule: {},
      repeatedBudgets: [],
      selectedSchedule: undefined
    }
  },
  mixins: [_modalHandlerMixin, validationMixin],
  computed: {
    budgets () {
      const fakeBudgetAll = {
        id: 'fake-option-all',
        name: this.$i18n.t('ALL'),
        code: 'ALL'
      }
      return [fakeBudgetAll, ...this.$store.getters['BudgetsStore/budgets']]
    },
    officeId () {
      return this.$store.getters['CompanyStore/currentCompany'].id
    },
    days () {
      let daysBoolean = {}
      days.forEach(item => { daysBoolean[item] = false })
      return daysBoolean
    }
  },
  methods: {
    daysSelected (days) {
      if (days && Object.keys(days)) {
        return Object.keys(days).filter(item => days[item] === true)
      }
      return {}
    },
    validateSchedule (invalid, days) {
      let validateDays = false
      if (!invalid) {
        Object.keys(days).forEach(item => {
          if (days[item] === true) validateDays = true
        })
        return !(!invalid && validateDays)
      }
      return true
    },
    selectDay (cardSchedule, day) {
      if (cardSchedule.days[day] === false || cardSchedule.days[day] === true) {
        cardSchedule.days[day] = !cardSchedule.days[day]
      } else {
        cardSchedule.days[day] = true
      }
      this.$forceUpdate()
    },
    showHoursAvailables (hour, state) {
      let hours = []
      hoursADay15Minutes.forEach(item => {
        if (state === 'start' && hour > item) {
          hours.push(item)
        } else if (state === 'finish' && item === '00:00') {
          hours.push('23:59')
        } else if (state === 'finish' && hour < item) {
          hours.push(item)
        }
      })

      return hours.sort()
    },
    notEditCardSchedule (cardSchedule) {
      if (typeof cardSchedule.id === 'string' && cardSchedule.id.includes('pm-new')) {
        this.cardsSchedule.splice(this.cardsSchedule.findIndex(item => item.id === cardSchedule.id), 1)
      } else {
        this.cardsSchedule.splice(this.cardsSchedule.findIndex(item => item.id === cardSchedule.id), 1, cardSchedule.original)
      }
      this.$forceUpdate()
    },
    editCardSchedule (cardSchedule) {
      if (typeof cardSchedule.id === 'string' && cardSchedule.id.includes('pm-new') && cardSchedule.editable) {
        const newCardScheduleId = cardSchedule.id
        this.cardsSchedule = this.cardsSchedule.filter(el => el.id !== newCardScheduleId)
      }
      cardSchedule.editable = !cardSchedule.editable
      if (cardSchedule.editable) {
        cardSchedule.original = Object.assign({ ...cardSchedule, editable: false })
      }
      this.$forceUpdate()
    },
    changeDefaultSchedule (cardSchedule) {
      cardSchedule.byDefault = true
      this.updateCardSchedule(cardSchedule)
    },
    handleClose () {
      this.closeModal()
    },
    handleDeleteCardSchedule (cardSchedule) {
      this.cardScheduleIdToDelete = cardSchedule.id
      this.showConfirmDeleteFlag = true
    },
    async fetchCardSchedules () {
      try {
        const response = await officeApi.getOfficeCardsSchedule()
        this.cardsSchedule = [...response.data]
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_cards_schedule_modal_get_cards_schedule_error' }, { root: true })
      }
    },
    async updateCardSchedule (cardSchedule) {
      try {
        const cardScheduleAux = { ...cardSchedule }
        if (cardSchedule.expenseTypes) {
          cardScheduleAux.expenseTypes = cardScheduleAux.expenseTypes.map(item => { return item.name })
        }
        cardScheduleAux.days = { ...this.days, ...cardSchedule.days }
        await officeApi.putOfficeCardSchedule(cardScheduleAux.id, cardScheduleAux)
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_cards_schedule_modal_update_error' }, { root: true })
      } finally {
        cardSchedule.editable = false
        this.$forceUpdate()
      }
    },
    async createCardSchedule (cardSchedule) {
      if (this.isCallingApi) return
      try {
        this.isCallingApi = true
        const originalCardScheduleId = cardSchedule.id
        const newCardSchedule = {
          ...cardSchedule
        }
        newCardSchedule.days = { ...this.days, ...newCardSchedule.days }
        delete newCardSchedule.id
        delete newCardSchedule.editable
        delete newCardSchedule.byDefault
        let response = await officeApi.postOfficeCardSchedule(newCardSchedule)
        let currentCardScheduleIndex = this.cardsSchedule.findIndex(el => el.id === originalCardScheduleId)
        if (response.data.forAllBudgets) {
          response.data.budgets = [...this.budgets.filter(el => el.code !== 'ALL')]
        }
        let updatedCardSchedule = {
          ...response.data,
          editable: false
        }
        this.cardsSchedule.splice(currentCardScheduleIndex, 1, updatedCardSchedule)
      } catch (error) {
        console.error(error)
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_cards_schedule_modal_create_error' }, { root: true })
      } finally {
        this.isCallingApi = false
      }
    },
    async deleteCardSchedule () {
      if (this.isCallingApi) return
      try {
        await officeApi.deleteOfficeCardSchedule(this.cardScheduleIdToDelete)
        this.cardsSchedule = this.cardsSchedule.filter(el => el.id !== this.cardScheduleIdToDelete)
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_cards_schedule_modal_delete_error' }, { root: true })
      } finally {
        this.cardScheduleIdToDelete = 0
        this.isCallingApi = false
      }
    },
    checkBudgets (cardSchedule, event) {
      if (event?.code === 'ALL') {
        cardSchedule.budgets = [...this.budgets.filter(el => el.code !== 'ALL')]
        cardSchedule.forAllBudgets = true
        cardSchedule.byDefault = true
      } else {
        cardSchedule.budgets.push(event)
      }
      if (cardSchedule.budgets.length === this.budgets.length - 1) {
        cardSchedule.forAllBudgets = true
        cardSchedule.byDefault = true
      }
    },
    removeBudget (cardSchedule, event) {
      cardSchedule.budgets = cardSchedule.budgets.filter(el => el.id !== event.id)
      cardSchedule.forAllBudgets = false
    },
    addCardSchedule () {
      this.cardScheduleFakeId++
      const cardSchedule = {
        id: `pm-new-${this.cardScheduleFakeId}`,
        name: '',
        days: {},
        hours: {
          startHour: '09:00',
          finishHour: '18:00'
        },
        budgets: [],
        forAllBudgets: false,
        editable: true,
        byDefault: false,
        original: {}
      }
      this.cardsSchedule.push(cardSchedule)
    },
    cardScheduleBudgets (cardSchedule) {
      if (cardSchedule.forAllBudgets) {
        return this.$i18n.t('ALL')
      }
      return cardSchedule.budgets.map(el => { return `${el.name}` }).join(', ')
    },
    handleSaveCardSchedule (cardSchedule) {
      this.repeatedBudgets = []
      this.selectedSchedule = cardSchedule
      let budgets = cardSchedule.budgets.map(item => item.id)
      this.cardsSchedule.forEach(item => {
        item.budgets.forEach(budget => {
          if (budgets.indexOf(budget.id) > -1 && cardSchedule.id !== item.id) {
            this.repeatedBudgets.push({ id: budget.id, name: budget.name })
          }
        })
      })
      if (this.repeatedBudgets.length === 0) {
        if (typeof cardSchedule.id === 'string' && cardSchedule.id.includes('new')) {
          this.createCardSchedule(cardSchedule)
        } else {
          this.updateCardSchedule(cardSchedule)
        }
      } else {
        this.showRepeatedBudgetsFlag = true
      }
    },
    overwriteBudgetCardSchedule () {
      let repeated = this.repeatedBudgets.map(item => item.id)
      this.cardsSchedule.forEach(item => {
        let overwrite = false
        if (item.id !== this.selectedSchedule.id) {
          item.budgets.forEach((budget, index) => {
            if (repeated.indexOf(budget.id) !== -1) {
              item.budgets.splice(index, 1)
              overwrite = true
            }
          })
        }
        if (overwrite) {
          this.updateCardSchedule(item)
        }
      })
      if (typeof this.selectedSchedule.id === 'string' && this.selectedSchedule.id.includes('new')) {
        this.createCardSchedule(this.selectedSchedule)
      } else {
        this.updateCardSchedule(this.selectedSchedule)
      }
    },
    async fetchBudgets () {
      const filters = {
        'status.code': 'ACTIVE',
        pagination: false
      }
      await this.$store.dispatch('BudgetsStore/setBudgetsFilters', filters)
    }
  },
  created () {
    let promises = [this.fetchCardSchedules(), this.fetchBudgets()]

    Promise.allSettled(promises).then(() => {
      this.cardsScheduleReady = true
      this.cardsSchedule.forEach(cardSchedule => {
        cardSchedule.editable = false
        cardSchedule.days = { ...this.days, ...cardSchedule.days }
        if (cardSchedule.forAllBudgets) {
          cardSchedule.budgets = [...this.budgets.filter(el => el.code !== 'ALL')]
        }
        if (cardSchedule.byDefault) {
          this.defaultSchedule = cardSchedule
        }
      })
    })
  },
  validations: {
    cardsSchedule: {
      $each: {
        name: { required },
        hours: {
          startHour: { required },
          finishHour: { required }
        },
        budgets: { required, minLength: minLength(1) }
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
#cardsScheduleModal {
  .Fuell-Table--row {
    position: relative;
  }
  &.ModalBox--r {
    width: 884px;
  }
  .Form-field {
    background: var(--fill-text-area);
    min-height: 32px;
    border-radius: 4px;
    margin: 0px;
    padding: 10px;
  }
  .Fuell-Text--name,
  .Form-field--name {
    width: 177px;
  }
  .Fuell-Text--days,
  .Form-field--days {
    width: 204px;
  }
  .Fuell-Text--hours,
  .Form-field--hours {
    width: 188px;
  }
  .Fuell-Text--budgets,
  .Form-field--budgets {
    width: 161px;
  }
  .input-toggle--block {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .Tit--modal {
    margin: 0px auto;
  }
  .cards-schedule--description {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--text-body);
  }
  .Fuell-Table--header,
  .Fuell-Table--row {
    grid-template-columns:
      200px 204px 188px
      161px 80px;
  }
  .Fuell-Table--header {
    .Fuell-Table--item {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: var(--text-heading);

      img {
        height: 13px;
        width: 13px;
      }
    }
  }
  .Fuell-Table--row {
    margin-bottom: 8px;
    &:hover:before {
      content: none;
    }
    .Fuell-Table--item {
      font-weight: 400;
      font-size: 13px;
      line-height: 32px;
      height: 32px;
      color: var(--text-body);
      margin: 0;
      padding-right: 0;
      &--text {
        position: relative;
        display: flex;
        align-items: center;
        height: 32px;
        .Fuell-Text {
          margin: 0;
        }
      }
      &--options {
        overflow: unset !important;
      }
      &--last {
        display: flex;
        justify-content: flex-end;
        padding: 0 8px;
      }
      .cards-schedule--edit-icon {
        display: none;
        margin-left: 7px;
      }
      &:hover {
        .cards-schedule--edit-icon {
          display: inline-block;
        }
      }
    }
  }
  .multiselect {
    min-height: 32px;
    max-height: 32px;
    height: 32px;
    .multiselect__tags,
    .multiselect__input,
    .multiselect__single,
    .caret {
      min-height: 32px !important;
      max-height: 32px;
      height: 32px;
      line-height: 32px;
    }
    &.multiselect--budgets {
      .multiselect__content-wrapper {
        width: 230px;
      }
    }
  }
  .Form-field {
    display: flex;
    align-items: center;
    min-height: 32px;
    max-height: 32px;
    height: 32px;
    padding: 4px 12px;

    &--days {
      .day-selectable {
        cursor: pointer;
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: var(--fill-text-area);
        margin-right: 4px;
        text-align: center;
        line-height: 24px;
        &.active {
          color: var(--white);
          background-color: var(--blue-action-1-active);
        }
        &:hover {
          color: var(--white);
          background-color: var(--blue-action-1-hover);
        }
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .cards-schedule--default {
    margin-top: 48px;
    &-title {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: var(--text-heading);
      margin-bottom: 4px;
    }
    &-description {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: var(--text-body);
      margin-bottom: 8px;
    }
    .multiselect {
      width: 364px;
      min-height: 46px;
      max-height: 46px;
      height: 46px;
      .multiselect__tags,
      .multiselect__input,
      .multiselect__single,
      .caret {
        min-height: 46px !important;
        max-height: 46px;
        height: 46px;
        line-height: 46px;
      }
    }
  }
  .cards-schedule--repeated {
    li {
      color: var(--text-body);
    }
  }

  .Input-text {
    padding: 0;
    color: var(--text-body);
  }

  .close-container {
    width: 20px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .close-line {
    width: 10px;
    height: 2px;
    background-color: var(--text-body);
    margin-right: 10px;
    cursor: pointer;
  }

  .remove-icon {
    display: none;
  }
  .Fuell-Table--row:hover {
    box-shadow: none;
    .remove-icon {
      display: flex;
    }
  }
  .Form--field-error {
    border: 1px solid var(--semantic-negative-main);
  }
  .multiselect--error {
    border: 2px solid var(--semantic-negative-main);
    border-radius: 6px;
  }
  .button-borderless {
    border: none;
    background-color: var(--white);
  }
  .disabled {
    color: var(--action-disabled) !important;
  }

  /* appearing */
  .input-transition-enter-active {
    transition: opacity 150ms ease-out, transform 150ms ease-out;
    transform: translate(-34px, 0);
  }
  .text-transition-enter-active {
    transition: opacity 150ms ease-out, transform 150ms ease-out;
    transform: translate(34px, 0);
  }

  /* disappearing */
  .input-transition-leave-active {
    transition: opacity 150ms ease-out, transform 150ms ease-out;
    transform: translate(-20px, 0);
  }
  .text-transition-leave-active {
    display: none;
    transition: opacity 150ms ease-out;
    opacity: 0;
  }

  .input-transition-enter,
  .input-transition-leave-to {
    transform: translate(-34px, 0);
    opacity: 0;
  }
  .text-transition-enter,
  .text-transition-leave-to {
    opacity: 0;
  }

  .input-transition-enter-to {
    position: absolute;
    transform: translate(0, 0);
  }
  .text-transition-enter-to {
    position: absolute;
    transform: translate(0, 0);
  }

  .cards-schedule-day-of-week--container-multiselect {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .multiselect {
      width: 80px;
      height: 32px;
      margin: 0;
      &.multiselect--disabled {
        background: transparent;
        color: var(--text-disabled) !important;
        opacity: 1;
        .caret {
          svg {
            border-color: var(--text-disabled) transparent transparent;
          }
        }
      }
      &.multiselect-start {
        .multiselect__tags {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      &.multiselect-finish {
        .multiselect__tags {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
      .multiselect__content-wrapper {
        width: auto;
        .multiselect__content {
          width: 90px;
        }
      }
      .multiselect__input {
        background-color: transparent;
      }
      .caret {
        height: 32px;
        width: 10px;
        margin-right: 0;
        padding: 4px 0;
        background: var(--fill-text-area);
      }
      .multiselect__tags {
        padding-right: 0;

        .multiselect__single {
          padding: 0;
        }
      }
      .multiselect__element {
        border-bottom: 1px solid var(--text-divider);
        &:last-child {
          border-bottom: none;
        }
      }
    }
    div.Fuell-TableInput--container,
    div.Fuell-TableInput {
      width: 123px;
      height: 32px;
      padding: 14px 12px;
      background-color: var(--fill-text-area);
      border-radius: 4px;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      color: var(--text-body);
      input {
        background-color: var(--fill-text-area);
      }
      .Fuell-TableInput--icon-container {
        display: none;
      }
    }
    input.Fuell-TableInput {
      height: 20px;
      line-height: 18px;
      padding: 0;
    }
    .cards-schedule-day-of-week--to-range {
      display: inline-block;
      height: 32px;
      width: 20px;
      background: var(--fill-text-area);
      font-weight: 400;
      font-size: 15px;
      line-height: 30px;
      color: var(--text-placeholder);
      text-align: center;
    }
    .disabled {
      color: var(--text-disabled) !important;
      .cards-schedule-day-of-week--to-range {
        color: var(--text-disabled) !important;
      }
    }
    label {
      display: flex;
      align-items: center;
      p {
        margin: 0 0 0 8px;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: var(--text-body);
      }
    }
  }
}
</style>
